module.exports = __webpack_public_path__ + "static/media/keftedakia-krema-kalampokiou.c0c9af45.jpg";